import * as actionTypes from '../types'
import {updateObject} from '../../utils/utility'

const initialState = {
    payload: null,
    errors: null,
    isLoading: false,
    isSucceedForGiveAnswer: null,
    isSucceedForGetQuizResult: null,  
};
const giveAnswerStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const giveAnswerSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGiveAnswer: action.isSucceedForGiveAnswer,
    });
};
const giveAnswerFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const giveAnswerReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGiveAnswer: action.isSucceedForGiveAnswer,
    });
};
const getQuizResultStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const getQuizResultSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGetQuizResult: action.isSucceedForGetQuizResult,
    });
};
const getQuizResultFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const getQuizResultReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGetQuizResult: action.isSucceedForGetQuizResult,
    });
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GIVE_ANSWER_USER_QUIZ_DETAIL_START:
            return giveAnswerStart(state,action);
        case actionTypes.GIVE_ANSWER_USER_QUIZ_DETAIL_SUCCESS:
            return giveAnswerSuccess(state,action);
        case actionTypes.GIVE_ANSWER_USER_QUIZ_DETAIL_FAIL:
            return giveAnswerFail(state,action);
        case actionTypes.GIVE_ANSWER_USER_QUIZ_DETAIL_RESET:
            return giveAnswerReset(state,action);
        case actionTypes.GET_QUIZ_RESULT_START:
            return getQuizResultStart(state, action);
        case actionTypes.GET_QUIZ_RESULT_SUCCESS:
            return getQuizResultSuccess(state, action);
        case actionTypes.GET_QUIZ_RESULT_FAIL:
            return getQuizResultFail(state, action);
        case actionTypes.GET_QUIZ_RESULT_RESET:
            return getQuizResultReset(state, action);
        default:
            return state;
    };
};

export default reducer;